import type * as React from 'react'

export const EmptyField = (): React.JSX.Element => {
  return <></>
}
